import React, { createContext, useState, useContext, useCallback } from 'react';

const AdminViewContext = createContext({
  isAdminView: false,
  adminSelectedFseId: null,
  adminSelectedFranchiseeName: null,
  startAdminView: () => {},
  endAdminView: () => {},
});

export const AdminViewProvider = ({ children }) => {
  const [isAdminView, setIsAdminView] = useState(false);
  const [adminSelectedFseId, setAdminSelectedFseId] = useState(null);
  const [adminSelectedFranchiseeName, setAdminSelectedFranchiseeName] = useState(null);

  const startAdminView = useCallback((fseId, franchiseeName) => {
    setAdminSelectedFseId(fseId);
    setAdminSelectedFranchiseeName(franchiseeName);
    setIsAdminView(true);
  }, []);

  const endAdminView = useCallback(() => {
    setIsAdminView(false);
    setAdminSelectedFseId(null);
    setAdminSelectedFranchiseeName(null);
  }, []);

  return (
    <AdminViewContext.Provider value={{ isAdminView, adminSelectedFseId, adminSelectedFranchiseeName, startAdminView, endAdminView }}>
      {children}
    </AdminViewContext.Provider>
  );
};

export const useAdminView = () => useContext(AdminViewContext);
